module.exports = __webpack_public_path__ + "media/customizations/granbyranch/back-a6fd3aea243c00f68c277c632e52f60c.jpg";